/* Optional rotation of the existing mobile trust strip; no duplicated items. */
(() => {
  if (customElements.get('lf-trust-strip')) return;
  customElements.define('lf-trust-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.autoRotate !== 'true') return;
      this.abort = new AbortController();
      this.mobile = matchMedia('(max-width:1023px)');
      this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
      this.items = [...this.querySelectorAll('.lf-trust-strip__item')];
      this.index = 0;
      this.paused = false;
      const options = { signal: this.abort.signal };
      const pause = () => { this.paused = true; this.schedule(); };
      ['pointerdown', 'wheel', 'keydown', 'focusin'].forEach(name => this.addEventListener(name, pause, options));
      [this.mobile, this.reduced].forEach(query => query.addEventListener('change', () => this.schedule(), options));
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || !this.mobile.matches || this.reduced.matches || document.hidden || this.items.length < 2 || this.scrollWidth <= this.clientWidth) return;
      this.timer = setTimeout(() => {
        this.index = (this.index + 1) % this.items.length;
        this.scrollTo({ left: this.items[this.index].offsetLeft - this.items[0].offsetLeft, behavior: 'smooth' });
        this.schedule();
      }, Number(this.dataset.interval) || 4000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
    }
  });
})();
